<template>
  <div style="height: 100%; position: relative;">
    <DashboardFilterChip :chip-color="chipColor" :chip-text="chipText"></DashboardFilterChip>
    <v-card style="height: 100%">
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" align="center">
            <h1>NTS by Employee</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div style="max-width: 40em; margin: 0 auto;">
              <div class="d-flex justify-end mb-2">
                <ButtonCustomIcon
                  icon="cloud_download"
                  color="primary"
                  text="Excel"
                  :disabled="showFetchingDataGIF || ntsByEmployeeData.length === 0"
                  @click="handleExportToExcel"
                />
              </div>
              <div style="max-height: 500px; overflow-y: auto;">
                <v-data-table
                  dense
                  :headers="grossProfitByEmployeeHeaders"
                  :items="ntsByEmployeeData"
                  :calculate-widths="true"
                  :items-per-page="10"
                  :footer-props="{ 'items-per-page-options': [10] }"
                  width="5em"
                >
                  <template v-slot:item.employeeName="{ item }">
                    {{ item.employeeName }}
                  </template>
                  <template v-slot:item.individualGrossProfit="{ item }">
                    {{ item.individualGrossProfit | currency }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row align="center" class="mt-2">
          <v-col cols="auto">
            <v-btn
              v-if="!showFetchingDataGIF"
              color="primary"
              outlined
              @click="refreshTile"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-col>
          <v-col class="text-right py-0">
            <i
              v-if="showFetchingDataGIF"
            >
              Fetching Data
            </i>
            <v-progress-circular
              v-if="showFetchingDataGIF"
              :size="30"
              :width="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <i
              v-if="lastRefreshTime"
              class="ml-2"
            >
              Last Update: {{ lastRefreshTime }}
            </i>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getLocalTimeString } from '@/lib/display'
import { isJSONString } from '@/lib/miscellaneous'
import DashboardFilterChip from '@/components/dashboard/DashboardFilterChip'
import { ButtonCustomIcon } from '@/components/buttons'
import excel from '@/lib/export/excel'
import { buildNtsByEmployeeExport } from './ntsByEmployeeExportHelpers'

export default {
  components: {
    DashboardFilterChip,
    ButtonCustomIcon
  },
  props: {
    businessEntityId: {
      type: Number,
      default: null
    },
    chipText: {
      type: String,
      default: 'All Business Entity'
    },
    chipColor: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      lastRefreshTime: null,
      showFetchingDataGIF: false,
      ntsByEmployeeData: [],
      grossProfitByEmployeeHeaders: [
        { text: 'Employee', value: 'employeeName', width: '250px' },
        { text: 'NTS', value: 'individualGrossProfit', width: '120px', align: 'right' }
      ]
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getNTSByEmployee'
    ]),
    handleExportToExcel () {
      if (!this.ntsByEmployeeData.length) {
        return
      }

      excel.exportArray2Excel(buildNtsByEmployeeExport({
        items: this.ntsByEmployeeData,
        headers: this.grossProfitByEmployeeHeaders
      }))
    },
    refreshTile () {
      this.showFetchingDataGIF = true
      this.getNTSByEmployee(this.businessEntityId).then((data) => {
        if (data && data.length > 0) {
          let dateTimeNow = new Date()
          this.ntsByEmployeeData = data
          localStorage.setItem('dashboard:nts-by-employee', JSON.stringify(data))
          localStorage.setItem('dashboard:nts-by-employee-last-refresh-time', JSON.stringify(dateTimeNow.toUTCString()))
          this.lastRefreshTime = getLocalTimeString(dateTimeNow)
        }
        this.showFetchingDataGIF = false
      })
    }
  },
  created () {
    if (localStorage.getItem('dashboard:nts-by-employee') && isJSONString(localStorage.getItem('dashboard:nts-by-employee'))) {
      this.ntsByEmployeeData = JSON.parse(localStorage.getItem('dashboard:nts-by-employee'))
    }
    if (localStorage.getItem('dashboard:nts-by-employee-last-refresh-time') &&
      isJSONString(localStorage.getItem('dashboard:nts-by-employee-last-refresh-time'))) {
      let lastRefreshTime = new Date(JSON.parse(localStorage.getItem('dashboard:nts-by-employee-last-refresh-time')))
      this.lastRefreshTime = getLocalTimeString(lastRefreshTime)
    }
    this.refreshTile()
  }
}
</script>
